module.exports = __webpack_public_path__ + "static/media/galerija_2013 (25).4eced03f.jpg";